import Network from '@/services/network'

export default function () {
    const network = new Network;

    const fetchStaffRegister = (query) => {
        return network.api('get', '/sdm/get-staff-register' + query);
    }

    const fetchStaffRegisterLineage = (query) => {
        return network.api('get', '/sdm/get-staff-register-lineage' + query);
    }

    const fetchSaleAllocations = (query) => {
        return network.api('get', '/sdm/sale-allocations' + query);
    }

    const storeSaleAllocations = (data,query) => {
        return network.api('post', '/sdm/sale-allocations' + query,data);
    }

    const deleteSaleAllocation = (id, query) => {
        return network.api('delete', `/sdm/sale-allocations/${id}` + query);
    }

    const fetchStaffSaleAllocations = (query) => {
        return network.api('get', '/sdm/staff-sale-allocations' + query);
    }

    const fetchSaleCommissions = (query) => {
        return network.api('get', '/sdm/get-sale-commission' + query);
    }

    const fetchSaleCommissionData = (query) => {
        return network.api('get', '/sdm/sale-commissions' + query);
    }

    const fetchSaleCommissionPayoutData = (query) => {
        return network.api('get', '/sdm/sale-commission-payout' + query);
    }

    const incentiveRegisterProcess = (query) => {
        return network.api('get', '/sdm/incentive-process' + query);
    }

    const fetchIncentiveProcessLogList = (query) => {
        return network.api('get', '/sdm/get-process-log' + query);
    }

    const contactProfileLevelUpdate = (query) => {
        return network.api('get', '/sdm/contact-profile-level-update' + query);
    }

    const updateIncentiveProcessType = (data, processId, query) => {
        return network.api('put', '/sdm/incentive-process/'+ processId + query, data);
    }

    const groupSaleCommissionProcess = (query) => {
        return network.api('get', '/sdm/group-sale-commission-process' + query);
    }

    const companySaleShareProcess = (query) => {
        return network.api('get', '/sdm/company-sale-share-process' + query);
    }

    const staffRegisterProcess = (query) => {
        return network.api('get', '/sdm/staff-register-process' + query);
    }

    const defaultRankUpdateProcess = (query) => {
        return network.api('get', '/sdm/default-rank-update-process' + query);
    }

    const fetchIncentiveAmount = (query) => {
        return network.api('get', '/sdm/get-incentive-amount' + query);
    }

    const storeIncentivePaymentVoucher = (data) => {
        return network.api('post', '/sdm/incentive-payment-voucher',data);
    }

    const fetchGenerationCommissionData = (query) => {
        return network.api('get', '/sdm/generation-commission' + query);
    }

    const createGenerationCommissionData = (data, query) => {
        return network.api('post', '/sdm/generation-commission' + query, data);
    }

    const fetchSingleIncentivePaymentVoucher = (id, query) => {
        return network.api('get', '/sdm/incentive-payment-voucher/' + id + query);
    }

    const createMinimumSaleAllocationAmount = (data, query) => {
        return network.api('post', '/sdm/minimum-allocated-sale-amount' + query, data);
    }

    const createServiceCharge = (data, query) => {
        return network.api('post', '/sdm/service-charge' + query, data);
    }

    const staffRegisterVerify = (data) => {
        return network.api('post', '/staff-user-verify', data);
    }

    const staffRegisterStore = (data) => {
        return network.api('post', '/staff-register', data);
    }

    const fetchSdmCommissionProfile = (query) => {
        return network.api('get', '/sdm/sdm-commission-profile' + query);
    }

    const changePassword = (data) => {
        return network.api('post', '/change-password', data);
    }

    return {
        fetchStaffRegister,
        fetchStaffRegisterLineage,
        fetchSaleAllocations,
        storeSaleAllocations,
        deleteSaleAllocation,
        fetchStaffSaleAllocations,
        fetchSaleCommissions,
        fetchSaleCommissionData,
        fetchSaleCommissionPayoutData,
        incentiveRegisterProcess,
        contactProfileLevelUpdate,
        fetchIncentiveProcessLogList,
        updateIncentiveProcessType,
        groupSaleCommissionProcess,
        companySaleShareProcess,
        staffRegisterProcess,
        defaultRankUpdateProcess,
        fetchIncentiveAmount,
        storeIncentivePaymentVoucher,
        fetchGenerationCommissionData,
        createGenerationCommissionData,
        fetchSingleIncentivePaymentVoucher,
        createMinimumSaleAllocationAmount,
        createServiceCharge,
        staffRegisterVerify,
        staffRegisterStore,
        fetchSdmCommissionProfile,
        changePassword,
    }
}